import { Show, type JSX } from "solid-js";
import { errorMessage } from "../api/errors";
import type { AsyncPanelState } from "../state/async";
import { formatRelativeTimestamp } from "../utils/format";

interface PanelStateProps<T> {
  state: AsyncPanelState<T>;
  onRetry: () => void;
}

export function PanelState<T>(props: PanelStateProps<T>): JSX.Element {
  return (
    <div class="panel-state">
      <span>{formatRelativeTimestamp(props.state.updatedAt)}</span>
      <Show when={props.state.status === "refreshing" || props.state.status === "loading"}>
        <span class="inline-loading">正在刷新</span>
      </Show>
      <Show when={props.state.status === "error"}>
        <span class="panel-state__error">
          {props.state.data === null ? "加载失败" : "当前数据可能已过期"}：
          {errorMessage(props.state.error)}
          <button type="button" class="text-button" onClick={props.onRetry}>
            重试
          </button>
        </span>
      </Show>
    </div>
  );
}
